import { useDictStore } from "@/stores/dictStore";

import { PricingStrategy, PriceResult } from "../base/pricing.strategy";
export class GlassOverdoorPricingStrategy extends PricingStrategy {
    private dictStore = useDictStore();

    public getPrices(...args: unknown[]): PriceResult {
        const [
            installedSystemCode,
            stateCode,
            glassSortCode,
            glassThicknessCode,
        ] = args as [string, string, string, string];

        const pricesFromDict = this.dictStore.findGlassPrice(
            glassSortCode,
            glassThicknessCode,
            stateCode,
        );

        if (!this.validatePricesFromDict(pricesFromDict)) {
            return this.getDefaultPrices();
        }

        return {
            price: pricesFromDict.price!,
            priceB2C: pricesFromDict.priceGlass!,
            priceB2B: pricesFromDict.priceEdging!,
        };
    }
}
